import numeral from "numeral";

numeral.register("locale", "es-es", {
  delimiters: {
    thousands: ".",
    decimal: ","
  },
  abbreviations: {
    thousand: "k",
    million: "mm",
    billion: "b",
    trillion: "t"
  },
  ordinal: function(number) {
    var b = number % 10;
    return b === 1 || b === 3
      ? "er"
      : b === 2
      ? "do"
      : b === 7 || b === 0
      ? "mo"
      : b === 8
      ? "vo"
      : b === 9
      ? "no"
      : "to";
  },
  currency: {
    symbol: "€"
  }
});

numeral.locale("es-es");

export const toDecimalString = (number,precision=2) => {
  let formatType = "0,0"
  for (let index = 0; index < precision; index++) {
    formatType+=(index===0 ? '.0' : '0')
  }
  
  return precision>0 ? numeral(number).format(formatType) : numeral(round(number,precision)).format(formatType)
};

export const toTimeString = number => {
  return numeral(number).format("00:00");
};

export const toTimeStringPDF = number => {
  return numeral(number).format("00:00").slice(0,4);
};

export const round = (number, precision) => {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
};

export const stringToFloat = (numberStr) => { return parseFloat(numberStr.replace(',','.'))}

export const stringToDecimal = (numberStr) => {return parseFloat(parseFloat(numberStr.replace('.','').replace(',','.')).toFixed(2))}
